module.exports = __webpack_public_path__ + "img/people.587f25f3.jpg";